"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactIDContext = exports.defaultContextValue = void 0;
var nanoid_1 = require("nanoid");
var react_1 = require("react");
var defaultContextValue = function () {
    console.warn('No ReactIDContext found. Falling back to nanoid - rehydration will not work properly.');
    return (0, nanoid_1.nanoid)();
};
exports.defaultContextValue = defaultContextValue;
exports.ReactIDContext = (0, react_1.createContext)(exports.defaultContextValue);
//# sourceMappingURL=react-id-context.js.map